import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

// ✅ Add to wishlist function
export const addToWishlist = async (wishlistData) => {
  try {
    console.log('📞 Adding to wishlist API call:', wishlistData);
    
    const response = await axiosInstance.post('/wishlist', wishlistData);
    
    console.log('✅ Wishlist item added successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Error adding to wishlist:', error);
    throw error;
  }
};

// ✅ Get wishlist items
export const getWishlistItems = async () => {
  try {
    console.log('📞 Fetching wishlist items...');
    
    const response = await axiosInstance.get('/wishlist');
    
    console.log('✅ Wishlist items fetched:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Error fetching wishlist items:', error);
    throw error;
  }
};

// ✅ Remove from wishlist
export const removeFromWishlist = async (wishlistItemId) => {
  try {
    console.log('📞 Removing from wishlist:', wishlistItemId);
    
    const response = await axiosInstance.delete(`/wishlist/${wishlistItemId}`);
    
    console.log('✅ Wishlist item removed successfully');
    return response.data;
  } catch (error) {
    console.error('❌ Error removing from wishlist:', error);
    throw error;
  }
};

// ✅ Update wishlist item
export const updateWishlistItem = async (wishlistItemId, updateData) => {
  try {
    console.log('📞 Updating wishlist item:', wishlistItemId, updateData);
    
    const response = await axiosInstance.put(`/wishlist/${wishlistItemId}`, updateData);
    
    console.log('✅ Wishlist item updated successfully');
    return response.data;
  } catch (error) {
    console.error('❌ Error updating wishlist item:', error);
    throw error;
  }
};